import { render, staticRenderFns } from "./spoilControl.vue?vue&type=template&id=4b68210b&scoped=true&"
import script from "./spoilControl.vue?vue&type=script&lang=js&"
export * from "./spoilControl.vue?vue&type=script&lang=js&"
import style0 from "./spoilControl.vue?vue&type=style&index=0&id=4b68210b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68210b",
  null
  
)

component.options.__file = "spoilControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VFlex,
  VIcon,
  VSelect,
  VTextField,
})
